import { apiGet } from './api-service';

const path = 'documents-signed';

export interface DocumentSignedDetails {
  document: {
    document_id: string;
    client_id: string;
    template_id: string | null;
    appointment_id: string;
    name: string;
    content: string;
    replacements: string;
    created_at: string;
    deleted_at: string | null;
  };
  document_signatures: Array<{
    document_signature_id: string;
    document_appointment_request_id: string;
    employee_id: string;
    signature_place_holder: string;
    signature_name: string;
    signature_s3_key: string;
    signed_at: string;
    signed_location: string;
    signature_place_holder_name: string;
    signature_place_holder_signed_at: string;
    created_at: string;
  }>;
}

export interface DocumentSigned {
  document_id: string;
  document_name: string;
  document_appointment_name: string;
  document_template_name: string | null;
  employee_id: string;
  employee_name: string;
  site_id: string;
  site_name: string;
  document_signature_id: string;
  signed_location: string | null;
  signed_at: string | null;
  created_at: string;
}

export async function getDocumentSignedById(id: string) {
  try {
    const response = await apiGet('core', `${path}/${id}`);
    return response;
  } catch (e) {
    throw e;
  }
}
